function inputGroupDirective() {
    'ngInject';

    return {
        restrict: 'A',
        require: 'ngModel',
        link(scope, elem, attrs, ngModel) {

            // return if the input has already been registered
            if (scope.input_manger.inputs.indexOf(ngModel.$name) >= 0) {
                return;
            }

            // register the input
            scope.input_manger.registerInput(ngModel, attrs.bbInputGroup);

            // watch the input for changes
            scope.$watch(attrs.ngModel, (newval, oldval) => {
                if (newval === !oldval) {
                    return scope.input_manger.validateInputGroup(attrs.bbInputGroup);
                }
            });
        }
    };
}

angular
    .module('BB.inputs')
    .directive('bbInputGroup', inputGroupDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-inputs/input-group/input_group.directive.js